export default __webpack_public_path__ + "static/atr-eaed063f138c9ac937b2db5583f77420.png";